/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { Col, Row } from "reactstrap";

const SplitField = ({columnProps, maxItemsPerRow, className, rowClass, colClass, children}) => {
  // constant prop counts
  const colProps1 = { xs: "12", sm: "12", md: "12", lg: "12", xl: "12" };
  const colProps2 = { xs: "12", sm: "12", md: "6", lg: "6", xl: "6" };
  const colProps3 = { xs: "12", sm: "12", md: "6", lg: "4", xl: "4" };
  const colProps4 = { xs: "12", sm: "12", md: "6", lg: "3", xl: "3" };
  const colProps6 = { xs: "12", sm: "6", md: "4", lg: "3", xl: "2" };

  // decide on column props
  let colProps;
  if (columnProps != null) {
    // use custom props if provided
    colProps = columnProps;
  } else {
    // choose based on specified items per row
    switch (maxItemsPerRow) {
      case "1": case 1: colProps = colProps1; break;
      case "3": case 3: colProps = colProps3; break;
      case "4": case 4: colProps = colProps4; break;
      case "6": case 6: colProps = colProps6; break;
      default: colProps = colProps2; break; // Default 2 items per row
    }
  }

  // children to list
  const list = Array.isArray(children) ? children : [ children ];

  return(
    <div className={className}>
      <Row className={rowClass ?? ""}>
        {list.map((item, index) => item ? (
          <Col className={colClass ?? "py-1"} key={index} {...colProps}>
            {item}
          </Col>
        ) : null)}
      </Row>
    </div>
  );
};

export default SplitField;
